import { useEffect, useState } from "react";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../../context/AlertContext";
import AuthService from "../../../../../../api/AuthService";
import NotesHomePage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/Notes/NotesHome";
import AssetsHomePage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/AssetsManagement/AssetsHome";

const AssetsHome = () => {
  const { showAlert } = useAlert();
  const [assetData, setAssetData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchAllAssets();
  }, []);

  const fetchAllAssets = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetAllAssets();
      if (result?.success) {
        setAssetData(result.data.assets);
        setTotal(result.data.total);
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result.message, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <>
      <AssetsHomePage
        assetsData={assetData}
        total={total}
        setTotal={setTotal}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
    </>
  );
};

export default AssetsHome;
